import $ from "jquery";
import axios from "axios";
import authHeader from "../auth-header";
import ErrorService from "../error.service";
import AdminService from "../admin.service";
import UserService from "../user.service";
import TableService from "../table.service";
import NeedsService from "../needs.service";
import ChartService from "../chart.service";

const BASE_URL = AdminService.getBaseUrl();
const API_URL = BASE_URL + "/api/v1/chart";

class ValueGroupMap {
    saveValueRoadMapFocusArea(surveyCode, valueRoadMapId, lift) {
        return this.updateValueRoadMapFocusArea("save", surveyCode, valueRoadMapId, lift);
    }
    removeValueRoadMapFocusArea(surveyCode, valueRoadMapId, lift) {
        return this.updateValueRoadMapFocusArea("remove", surveyCode, valueRoadMapId, lift);
    }
    async updateValueRoadMapFocusArea(action, surveyCode, valueRoadMapId, lift) {
        const params = new URLSearchParams();
        params.append("surveyCode", surveyCode);
        params.append("valueRoadMapId", valueRoadMapId);
        params.append("lift", JSON.stringify(lift));
        params.append("userId", UserService.getUserId());
        const response = await axios.post(API_URL + `/${action}-value-road-map-focus-area`, params, { headers: await authHeader() });
        if (response.data.statusCode !== 200) {
            throw new Error(response.data.message || "Unable to update Focus.");
        }
        return response;
    }
    async getValueRoadMapInitiative(surveyCode,needNumber, needType, valueRoadMapId, callback, panelApp) {
        const params = new URLSearchParams();
        params.append("surveyCode", surveyCode);
        params.append("needNumber", needNumber);
        params.append("needType", needType);
        params.append("valueRoadMapId", valueRoadMapId);
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_URL + "/get-value-road-map-initiative", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("Winners.getValueRoadMapInitiative", error, "survey-designer", panelApp);
          });
    }    
    async saveValueRoadMapInitiative(surveyCode, valueRoadMapInitiatives, valueRoadMapId, callback, panelApp) {
        const params = new URLSearchParams();
        params.append("surveyCode", surveyCode);
        params.append("valueRoadMapInitiatives", JSON.stringify(valueRoadMapInitiatives));
        params.append("valueRoadMapId", valueRoadMapId);
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_URL + "/save-value-road-map-initiative", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("ValueGroupMap.saveValueRoadMapInitiative", error, "survey-designer", panelApp);
          });
    }    
    async getValueRoadMapSetupBySurveyCode(surveyCode, clientChartId, period, surveyGroupId, useEqualWeight, callback, panelApp) {
        const params = new URLSearchParams();
        params.append("surveyCode", surveyCode);
        params.append("clientChartId", clientChartId);
        params.append("period", period);
        params.append("surveyGroupId", surveyGroupId);
        params.append("useEqualWeight", useEqualWeight);
        params.append("userId", UserService.getUserId());
        await axios
          .post(API_URL + "/get-value-road-map-setup-map-by-survey-code", params, { headers: await authHeader() })
          .then(response => callback(response))
          .catch(error => {
            error.message += ErrorService.mergeError(error.response);
            ErrorService.processError("ValueGroupMap.getValueRoadMapSetupBySurveyCode", error, "survey-designer", panelApp);
          });
      }    
      getRoadMapInitiativesTableColumnData() {
        return [
          {
            data: null,
            defaultContent: "",
            className: "text-center radio-button",
            name: "moatInitiativeId",
            width: "1rem",
            bVisible: true,
            render: function (data, type, row, meta) {
              return `<input type="radio" name="initiativeRadio" value="${row.moatInitiativeId}" class="select-radio suggestions-popup-radio">`;
            }
          },
          { data: "initiative", name: "initiative", width: "18.5rem", class: "text-left pr-2"},
          {
            data: "attributes",
            name: "attributes.successLevel",
            width: "2.8rem",
            className: "text-center",
            render: function (data, type, row) {
              try {
                const attrs = typeof row.attributes === "string" ? JSON.parse(row.attributes || "{}") : (row.attributes || {});
                return attrs.successLevel || "";
              } catch (e) {
                return "";
              }
            }
          },
          {
            data: "attributes",
            name: "attributes.salesIncrease",
            width: "3rem",
            className: "text-center",
            render: function (data, type, row) {
              try {
                const attrs = typeof row.attributes === "string" ? JSON.parse(row.attributes || "{}") : (row.attributes || {});
                return attrs.salesIncrease || "";
              } catch (e) {
                return "";
              }
            }
          },
          {
            data: "attributes",
            name: "attributes.costReduction",
            width: "3rem",
            className: "text-center",
            render: function (data, type, row) {
              try {
                const attrs = typeof row.attributes === "string" ? JSON.parse(row.attributes || "{}") : (row.attributes || {});
                return attrs.costReduction || "";
              } catch (e) {
                return "";
              }
            }
          }
        ];
      }
      getRoadMapEffortSetsTableColumnData() {
        return [
          {
            title: "Initiative",
            data: null,
            defaultContent: "",
            name: "initiativeIcon",
            width: "3rem",
            className: "text-center",
            orderable: false,
            render: function () {
              return '<img src="/img/chart-headers/w-logo-solid.svg" class="icon-table-view roadmap-initiative-display" alt="wRatings" style="width: 20px; height: 20px;"/>';
            }
          },
          {
            title: "Focus",
            data: "savedFocus",
            defaultContent: "",
            name: "savedFocus",
            width: "2rem",
            className: "text-center",
            orderable: false,
            render: function (data, type, row, meta) {
              const checked = row.savedFocus ? " checked" : "";
              return `<input type="checkbox" name="roadmapFocus[]" value="${meta.row}" class="roadmap-focus-checkbox"${checked}>`;
            }
          },
          { title: "Grade", data: "category", defaultContent: "--", name: "category", width: "8rem", className: "text-left", orderable: false },
          { title: "Need", data: "need", defaultContent: "", name: "need", width: "10rem", className: "text-left", orderable: false },
          { title: "Summary", data: "summary", defaultContent: "", name: "summary", width: "16rem", className: "text-left selected-initiative", orderable: false },
          { title: "The Action", data: "action", defaultContent: "", name: "action", width: "28rem", className: "text-left selected-initiative", orderable: false }
        ];
      }
}
export default new ValueGroupMap();
